import { render } from "./AppSubmenu.vue?vue&type=template&id=7c24f0e5"
import script from "./AppSubmenu.vue?vue&type=script&lang=ts"
export * from "./AppSubmenu.vue?vue&type=script&lang=ts"
script.render = render

export default script